import { AxiosResponse } from 'axios'
import dayjs from 'dayjs'
import { LocationQueryValue } from 'vue-router'

export const isColWide = (value: string, dates: string[]) => value.substring(0, 4) !== dates[0].substring(0, 4)
export const formatCurrency = (value: number) => value.toLocaleString('ru-RU', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  useGrouping: true
})
export const parseDate = (value: string|LocationQueryValue) => dayjs(value, { format: 'YYYY-MM-DD' }).toDate()
export const dateToString = (value: Date) => dayjs(value).format('YYYY-MM-DD')
export const formatDate = (value: string) => dayjs(value, { format: 'YYYY-MM-DD' }).format('DD.MM.YYYY')

export const downloadFile = async (axiosResponse: AxiosResponse<Blob>, title: string) => {
  const href = URL.createObjectURL(axiosResponse.data)
  const link = document.createElement('a')

  link.href = href
  link.setAttribute('download', title)
  link.click()
  URL.revokeObjectURL(href)
}

export const shortString = (value: string, maxLength = 12) => value.length > maxLength ? value.substring(0, maxLength) + '...' : value
